import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/main/main'
// import businessMain from '@/components/main/businessMain'
import mainContent from '@/components/layout/mainContent'
// import login from '@/components/login/login'
import store from '../store'
import {myPost, myGet} from '@/api/http'
import { resolve } from 'tinymce'

Vue.use(Router)

const router =  new Router({
  // mode: "history",
  routes: [
    {
      path:'/',
      redirect: '/',
      component: main,
      children: [
        {
          path: '/',
          meta: { title: '首页',require: true},
          component: (resolve) => require(['@/base/home/home'], resolve),
        },
        {
          path: '/course',
          meta: { title: '课程报名',require: true},
          component: (resolve) => require(['@/base/home/home'], resolve),
        },
        {
          path: '/train',
          meta: { title: '考级培训',require: true},
          component: (resolve) => require(['@/base/home/train'], resolve),
        },
        {
          path: '/details',
          meta: { title: '课程详情',require: true},
          component: (resolve) => require(['@/base/home/details'], resolve),
        },
        {
          path: '/details/:id',
          meta: { title: '课程详情',require: true},
          component: (resolve) => require(['@/base/home/details'], resolve),
        },
        // {
        //   path: 'business/:id',
        //   meta: { title: '业务系统',require: true},
        //   component: (resolve) => require(['@/base/home/businessSystem'], resolve)
        // },
      ]
    },
    //会员中心
    {
      path: '/member_center',
      redirect: '/member_center/home',
      meta: { title: '会员中心',type: 'member'},
      component: main,
      children: [
        {
          path: 'home',
          meta: { title: '账户首页',type: 'member',require: true},
          component: (resolve) => require(['@/base/member/home/home'], resolve)
        },
        {
          path: 'account_config',
          meta: { title: '账户设置',type: 'member'},
          redirect: 'account_config/info'
        },
        {
          path: 'account_config/info',
          meta: { title: '账户信息',type: 'member'},
          component: (resolve) => require(['@/base/member/account/info'], resolve)
        },
        {
          path: 'account_config/address',
          meta: { title: '地址管理',type: 'member'},
          component: (resolve) => require(['@/base/member/account/address'], resolve)
        },
        {
          path: 'account_config/auth',
          meta: { title: '我的认证',type: 'member'},
          component: (resolve) => require(['@/base/member/account/auth'], resolve)
        },
        {
          path: 'order_center',
          meta: { title: '订单中心',type: 'member'},
          redirect: 'order_center/item'
        },
        {
          path: 'order_center/item',
          meta: { title: '我的项目',type: 'member'},
          component: (resolve) => require(['@/base/member/order/item'], resolve)
        },
        {
          path: 'order_center/order',
          meta: { title: '我的订单',type: 'member'},
          component: (resolve) => require(['@/base/member/order/order'], resolve)
        },
        {
          path: 'order_center/order/detail/:id',
          meta: { title: '订单详情',type: 'member'},
          component: (resolve) => require(['@/base/member/order/orderDetail'], resolve)
        },
        {
          path: 'order_center/renew',
          meta: { title: '续费查询',type: 'member'},
          component: (resolve) => require(['@/base/member/order/renew'], resolve)
        },
        {
          path: 'order_center/renew/detail/:id',
          meta: { title: '续费详情',type: 'member'},
          component: (resolve) => require(['@/base/member/order/renewDetail'], resolve)
        },
        {
          path: 'order_center/prize',
          meta: { title: '中奖记录',type: 'member'},
          component: (resolve) => require(['@/base/member/order/prize'], resolve)
        },
        {
          path: 'order_center/e-invoice',
          meta: { title: '电子发票',type: 'member'},
          component: (resolve) => require(['@/base/member/order/invoice'], resolve)
        },
        {
          path: 'my_card',
          meta: { title: '我的卡包',type: 'member'},
          redirect: 'my_card/coupon'
        },
        {
          path: 'my_card/coupon',
          meta: { title: '优惠券',type: 'member'},
          component: (resolve) => require(['@/base/member/card/coupon'], resolve)
        },
        {
          path: 'my_kgu',
          meta: { title: '我的空谷',type: 'member'},
          redirect: 'my_kgu/wallet'
        },
        // {
        //   path: 'item_manage/edit',
        //   name: 'editProject',
        //   meta: { title: '编辑项目管理',type: 'member'},
        //   component: (resolve) => require(['@/base/member/item/edititem'], resolve)
        // },
      ]
    },
    /* {
      path: "/business",
      component: businessMain,
      children: [
        {
          path: '/:id',
          meta: { title: '业务系统',require: true},
          component: (resolve) => require(['@/base/home/businessSystem'], resolve)
        },
      ]
    }, */
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面meta */
//   console.log(to.meta.content)
//   if(to.meta.content){
//     let head = document.getElementsByTagName('head');
//     let meta = document.createElement('meta');
//     document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
//     document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
//     meta.content = to.meta.content;
//     console.log(meta[name="keywords"])
//     head[0].appendChild(meta)
//   }
//   // /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   }
//   next()
// });





router.beforeEach((to,from, next) => {
  // if (to.meta.require) {
  //   if (localStorage.getExpire('isLogin')!=='true') {
  //     next({
  //       path: '/login',
  //       query: {redirect: to.fullPath}  // 将跳转首页时的路由path作为参数，登录成功后跳转到该路由
  //     })
  //   }
  // }

  if (!localStorage.getExpire('Lang')) {
    localStorage.setExpire('Lang','ZH_CN')
    next()
  }
  if (!localStorage.getExpire('justOnce')) {
    localStorage.setExpire('justOnce',true)
    next()
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js